import { render, staticRenderFns } from "./menuPage.vue?vue&type=template&id=1d588b9b&scoped=true&"
import script from "./menuPage.vue?vue&type=script&lang=js&"
export * from "./menuPage.vue?vue&type=script&lang=js&"
import style0 from "./menuPage.vue?vue&type=style&index=0&id=1d588b9b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d588b9b",
  null
  
)

export default component.exports